// extracted by mini-css-extract-plugin
export default {"navigation":"Oul88Ogxo7WzjT0Y3S9A","menuSectionWrapper":"D7sBWTlIo33GXITVPVd_"};